import React from 'react'
import { connect } from 'react-redux'
import { reduxForm, getFormValues, SubmissionError } from 'redux-form'
import { Button, Breadcrumb, Confirm } from 'semantic-ui-react'
import { lower } from 'change-case'

import { scrollToFirstValidateFailElement } from 'core/utilities'
import { validation, validateCase as vCase } from 'core/validate'
import Information from '../Shareds/Information'
import ActionCommentModal from '../Shareds/ActionCommentModal'
import Attachment from '../Shareds/Attachment'
import { goodsServiceReceiptPath } from 'routes'
import {
  validateField,
  validateAttachments,
  setUpGRPOs,
  setUpGRPOItems,
  checkAlertContract
} from '../helper'
import { 
  MainBodyContent, 
  K2ErrorModal, 
  CustomButton,
} from 'components'
import { 
  clearGRDetail,
  fetchPORelease,
  createGR,
  initializeGR,
  getGRGOAWorkFlowEditMode,
  checkDuplicateInvoice,
  clearCheckDuplicateInvoice
} from 'ducks/goodsServiceReceipt'
import { 
  showModal,
} from 'ducks/app'
import r from 'reactotron-react-js'

import { BottomActionsContainer } from './styled'

const CreateGoodsServiceReceipt = props => {

  const { 
    history,
    change,
    userName,
    goaWorkFlow,
    valueForm,
    k2workFlowError,
    invDuplicate,
    isDetail = false,
  } = props

  const [actionName, setActionName] = React.useState('')
  const [showConfirmDI, setShowConfirmDI] = React.useState(false)
  const [showConfirmSubmit, setShowConfirmSubmit] = React.useState(false)
  const [showConfirmAlertContract, setShowConfirmAlertContract] = React.useState(false)
  const [messageAlertContract, setMessageAlertContract] = React.useState([])
  const [requireMemo, setRequireMemo] = React.useState(false)

  let dataFromCheckDuplicateInvoice = false

  React.useEffect(() => {
    window.scrollTo(0,0)
    props.initializeGR(isDetail)
    props.fetchPORelease()
    return (() => {
      props.clearGRDetail()
      props.clearCheckDuplicateInvoice()
    })
  },[])
  
  React.useEffect(() => {
    if(invDuplicate){
      setShowConfirmDI(true)
    }
  },[invDuplicate])

  React.useEffect(() => {
    props.getGRGOAWorkFlowEditMode({
      creater:userName,
      requester:valueForm?valueForm.requesterUser:'',
      companyCode:valueForm?valueForm.goodsServiceReceiptPOs.length?valueForm.goodsServiceReceiptPOs[0].companyCode:'':'',
      poSapNumber:valueForm?valueForm.goodsServiceReceiptPOs.length?valueForm.goodsServiceReceiptPOs[0].purchaseOrderSapNumber:'':'',
      amount:valueForm?valueForm.billingAmount:'',
      currency:valueForm?valueForm.goodsServiceReceiptPOs.length?valueForm.goodsServiceReceiptPOs[0].currencyCode:'':'',
      vendorCode:valueForm?valueForm.goodsServiceReceiptPOs.length?valueForm.goodsServiceReceiptPOs[0].vendorCode:'':'',
      goaId:valueForm?valueForm.goodsServiceReceiptPOs.length?valueForm.goodsServiceReceiptPOs[0].goaid:'':'',
      specialApprovalId:valueForm?valueForm.specialApprovalId:'',
      porjectManagerUsername:valueForm?valueForm.projectManagerUser:'',
      isFromVendor:valueForm?valueForm.isFromVendor:'',
    })
  },[(userName),(valueForm&&valueForm.requesterUser),(valueForm&&valueForm.projectManagerUser),
    (valueForm&&valueForm.goodsServiceReceiptPOs),(valueForm&&valueForm.billingAmount),(valueForm&&valueForm.specialApprovalId)])

  React.useEffect(()=>{
    if(valueForm&&valueForm.goodsServiceReceiptPOs&&valueForm.goodsServiceReceiptPOs.length>0){
      setRequireMemo(false)
    }
  },[valueForm&&valueForm.goodsServiceReceiptPOs])

  const onSubmitForm = () => {
    const sleep = ms => new Promise(resolve => setTimeout(resolve, ms))
    return sleep(100)
    .then(() => {
      let errors = validateField(valueForm)
      setShowConfirmSubmit(false)
      if(Object.keys(errors).length){
        scrollToFirstValidateFailElement(errors)
        throw new SubmissionError(errors)
      }else{
        let missingAttachments = validateAttachments(valueForm, props.grType.data)
        if(missingAttachments.length){
          props.showModal(
            true, 
            'Please attach document!',
            <React.Fragment><ul>{missingAttachments.map(v => <li>{v.fieldName}</li>)}</ul></React.Fragment>
          )
        }else{
          let data = {...valueForm,goodsServiceReceiptPoItems:setUpGRPOItems(valueForm),goodsServiceReceiptPOs:setUpGRPOs(valueForm),vendorCode:valueForm.goodsServiceReceiptPOs[0].vendorCode}
          if(actionName==='save'){
            props.checkDuplicateInvoice(data,history,false)
          }else{
            let check = checkAlertContract(valueForm)
            if(check.alert){
              setRequireMemo(true)
              setMessageAlertContract(check.msgAlert)
              dataFromCheckDuplicateInvoice = true
              setShowConfirmAlertContract(true)
            }else{
              setRequireMemo(false)
              props.checkDuplicateInvoice(data,history,true)
            }
          }
        }
      }
    })
  } 

  const confirmSubmit = () =>{
    setShowConfirmDI(false)
    let data = {...valueForm,goodsServiceReceiptPoItems:setUpGRPOItems(valueForm),goodsServiceReceiptPOs:setUpGRPOs(valueForm)}
    if(actionName==='save'){
      props.createGR(data, history, false)
    }else{
      let check = checkAlertContract(valueForm)
      if(check.alert){
        setRequireMemo(true)
        setMessageAlertContract(check.msgAlert)
        dataFromCheckDuplicateInvoice = false
        setShowConfirmAlertContract(true)
      }else{
        setRequireMemo(false)
        props.createGR(data, history, true)
      }
    }
  }

  const confirmAlertContractSubmit = () =>{
    setShowConfirmAlertContract(false)
    let missingAttachments = validateAttachments(valueForm, props.grType.data, requireMemo)
    if(missingAttachments.length){
      props.showModal(
        true, 
        'Please attach document!',
        <React.Fragment><ul>{missingAttachments.map(v => <li>{v.fieldName}</li>)}</ul></React.Fragment>
      )
    }else{
      if(dataFromCheckDuplicateInvoice){
        let data = {...valueForm,goodsServiceReceiptPoItems:setUpGRPOItems(valueForm),goodsServiceReceiptPOs:setUpGRPOs(valueForm),vendorCode:valueForm.goodsServiceReceiptPOs[0].vendorCode}
        props.checkDuplicateInvoice(data,history,true)
      }else{
        let data = {...valueForm,goodsServiceReceiptPoItems:setUpGRPOItems(valueForm),goodsServiceReceiptPOs:setUpGRPOs(valueForm)}
        props.createGR(data, history, true)
      }
    }
  }

  return (
    <MainBodyContent
      headerTitle='Goods Service Receipt - Create '
      accessoriesHeader={
        <div style={{ display: 'flex' }}>
          <CustomButton
            onClick={() => props.history.push(goodsServiceReceiptPath)}
            icon="close"
            btnColor="red"
            title="Cancel"
          />
        </div>
      }
      breadcrumbs={
        <Breadcrumb
          icon="right angle"
          sections={[
            {
              key: 'GR',
              content: 'Goods Service Receipt',
              link: true,
              onClick: () => history.push(goodsServiceReceiptPath),
            },
            { key: 'GREdit', content: 'Create', active: true },
          ]}
        />
      }
      accessoriesHeaderLeft={
        k2workFlowError.isError&&
          <K2ErrorModal/>  
      }
    >
      <Information isCreate={true} isEdit={false} change={props.change}/>

      {valueForm&&valueForm.subDeliveryType&&
      <Attachment isCreate={true} isEdit={false} change={change} requireMemo={requireMemo}/>}
      {/* Dialog DI */}
      <Confirm
        open={showConfirmDI}
        content='This invoice number already exits, Do you want to reference invoice number with current delivery note?'
        onCancel={()=>setShowConfirmDI(false)}
        onConfirm={()=>confirmSubmit()}
      />
      {/* Confirm alert contract */}
      <Confirm
        open={showConfirmAlertContract}
        content={<div className='content' style={{whiteSpace:'pre-line'}}>{messageAlertContract.map(x=>x)}</div>}
        onCancel={()=>setShowConfirmAlertContract(false)}
        onConfirm={()=>confirmAlertContractSubmit()}
      />
      <form onSubmit={props.handleSubmit(()=>onSubmitForm())}>
        <BottomActionsContainer>
          <Button 
            type='submit'
            content='Save' 
            icon='save' 
            labelPosition='right'
            style={{ marginRight: '5px' }}
            onClick={()=>setActionName('save')}
          />
          <Button 
            type='button'
            content='Save & Submit' 
            color='blue' 
            icon='save' 
            labelPosition='right'
            style={{ marginRight: '5px' }}
            onClick={()=>{setActionName('submit');setShowConfirmSubmit(true)}}
          />
        </BottomActionsContainer>
      </form>
      {showConfirmSubmit&&<ActionCommentModal submit={props.handleSubmit(()=>onSubmitForm())} setShowDialogComment={setShowConfirmSubmit} actionName={actionName}/>}
    </MainBodyContent>
  )

}

const validate = values => {
  let errors = {}  
  errors = validation(values, 'invoiceNumber', [vCase.maxLength20], errors)

  return errors
}

const mapStateToProps = (state, props) => {
  const date = new Date()
  const userName = state.authen.user ? state.authen.user.username ? state.authen.user.username : '' : ''
  let requesterUser = ''
  if (userName) {
    requesterUser = lower(userName)
  }
  return ({
    initialValues: {
      goodsServiceReceiptPOs:[],
      goodsServiceReceiptPoItems:[],
      goodsServiceReceiptAttachments:[],
      documentDate:new Date(date.getFullYear(), date.getMonth(), date.getDate()),
      postingDate:new Date(date.getFullYear(), date.getMonth(), date.getDate()),
      invoiceDate:new Date(date.getFullYear(), date.getMonth(), date.getDate()),
      requesterUser:requesterUser,
    },
    userName,
    goaWorkFlow: state.gr.goaWorkFlow,
    k2workFlowError: state.gr.k2workFlowError,
    invDuplicate: state.gr.invDuplicate,
    grType: state.gr.grType,
    valueForm: getFormValues('formGR')(state),
  })
}
const mapDispatchToProps = {
  clearGRDetail,
  fetchPORelease,
  createGR,
  initializeGR,
  showModal,
  getGRGOAWorkFlowEditMode,
  checkDuplicateInvoice,
  clearCheckDuplicateInvoice
}

const contForm = reduxForm({
  form: 'formGR',
  enableReinitialize: true,
  validate
})(CreateGoodsServiceReceipt)

export default connect(mapStateToProps, mapDispatchToProps)(contForm)
